// extracted by mini-css-extract-plugin
export var description = "hero-module--description--7b073";
export var effect = "hero-module--effect--78034";
export var effect__1 = "hero-module--effect__1--3b3f7";
export var effect__1color = "hero-module--effect__1color--375ce";
export var effect__2 = "hero-module--effect__2--832dd";
export var effect__2color = "hero-module--effect__2color--c7b62";
export var gridWrapper__black = "hero-module--gridWrapper__black--c47c2";
export var gridWrapper__bloodorange = "hero-module--gridWrapper__bloodorange--9775d";
export var gridWrapper__chartruse = "hero-module--gridWrapper__chartruse--96e7e";
export var gridWrapper__cobalt = "hero-module--gridWrapper__cobalt--35747";
export var gridWrapper__emerald = "hero-module--gridWrapper__emerald--37228";
export var gridWrapper__paper = "hero-module--gridWrapper__paper--5a544";
export var gridWrapper__pink = "hero-module--gridWrapper__pink--57f2d";
export var gridWrapper__sky = "hero-module--gridWrapper__sky--13ee0";
export var gridWrapper__white = "hero-module--gridWrapper__white--bd76a";
export var hero = "hero-module--hero--43dca";
export var hero__black = "hero-module--hero__black--d9c51";
export var hero__bloodorange = "hero-module--hero__bloodorange--39e05";
export var hero__chartruse = "hero-module--hero__chartruse--c06ed";
export var hero__cobalt = "hero-module--hero__cobalt--f4b1a";
export var hero__dark = "hero-module--hero__dark--9efc0";
export var hero__emerald = "hero-module--hero__emerald--e32a0";
export var hero__flip = "hero-module--hero__flip--d90fd";
export var hero__full = "hero-module--hero__full--d6a8e";
export var hero__grid = "hero-module--hero__grid--c700f";
export var hero__gridLight = "hero-module--hero__gridLight--d7134";
export var hero__open = "hero-module--hero__open--5fc91";
export var hero__paper = "hero-module--hero__paper--08e2f";
export var hero__pink = "hero-module--hero__pink--362b8";
export var hero__sky = "hero-module--hero__sky--0f728";
export var hero__white = "hero-module--hero__white--09209";
export var illustration = "hero-module--illustration--edbec";
export var image = "hero-module--image--4d80c";
export var image__full = "hero-module--image__full--d5da3";
export var left = "hero-module--left--fd87b";
export var right = "hero-module--right--961f8";
export var spin = "hero-module--spin--6bf39";
export var wrapper = "hero-module--wrapper--db9fc";